var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPromoHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "url(#paint0_linear_1194_25538)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8459 52.334C56.6545 52.334 57.3108 52.9902 57.3108 53.7988C57.3108 54.6074 56.6545 55.2637 55.8459 55.2637C55.0375 55.2637 54.3811 54.6074 54.3811 53.7988C54.3811 52.9902 55.0375 52.334 55.8459 52.334Z",
    fill: "#EDAD0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 28.8965C16.6673 28.8965 17.76 29.9893 17.76 31.3379C17.76 32.6865 16.6673 33.7793 15.3186 33.7793C13.97 33.7793 12.8772 32.6865 12.8772 31.3379C12.8772 29.9893 13.97 28.8965 15.3186 28.8965Z",
    fill: "#EDAD0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.261 14.8125C16.9183 14.8711 18.3821 15.7373 19.2727 17.0332C19.3176 17.0996 19.3616 17.167 19.4047 17.2354C19.4475 17.3037 19.4885 17.374 19.5277 17.4443C19.8041 17.9395 20.0004 18.4854 20.1019 19.0635C20.1517 19.3525 20.1781 19.6494 20.1781 19.9531H15.2601C11.9574 19.9531 11.7748 15.0117 15.0726 14.8203C15.135 14.8164 15.1976 14.8145 15.261 14.8125Z",
    fill: "#CBE9FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5452 49.8672H47.6966H52.428C52.428 53.1592 50.2708 54.8984 47.6946 54.8984H26.135H26.092C27.2864 54.7813 28.4338 54.3105 29.2834 53.4766C30.1321 52.6416 30.6829 51.4424 30.6829 49.8672H47.5452Z",
    fill: "#CBE9FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5871 14.8086H20.179H44.7786H44.8264C46.3244 14.8086 47.5432 16.0244 47.5432 17.5215C47.5432 30.6553 47.5451 38.3291 47.5451 49.8672H30.6828C30.6828 51.4424 30.1321 52.6416 29.2834 53.4766C28.4339 54.3105 27.2865 54.7812 26.092 54.8984H24.9104C22.5206 54.7119 20.2257 53.0273 20.1789 49.8936V19.9531C20.1789 19.6494 20.1525 19.3525 20.1018 19.0635C20.0012 18.4854 19.8039 17.9395 19.5276 17.4443C19.4885 17.374 19.4475 17.3037 19.4045 17.2354C19.3624 17.167 19.3175 17.0996 19.2726 17.0332C18.382 15.7373 16.9182 14.8711 15.2609 14.8125C15.2286 14.8115 15.1975 14.8086 15.1661 14.8086H15.4337H15.5871Z",
    fill: "#E4F4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7424 14.248C50.1469 14.248 50.4749 13.9201 50.4749 13.5156C50.4749 13.1111 50.1469 12.7832 49.7424 12.7832C49.3379 12.7832 49.01 13.1111 49.01 13.5156C49.01 13.9201 49.3379 14.248 49.7424 14.248Z",
    fill: "#76CAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.469 57.2168C19.8735 57.2168 20.2014 56.8889 20.2014 56.4844C20.2014 56.0799 19.8735 55.752 19.469 55.752C19.0645 55.752 18.7366 56.0799 18.7366 56.4844C18.7366 56.8889 19.0645 57.2168 19.469 57.2168Z",
    fill: "#76CAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0042 24.0137C18.4087 24.0137 18.7366 23.6858 18.7366 23.2812C18.7366 22.8767 18.4087 22.5488 18.0042 22.5488C17.5996 22.5488 17.2717 22.8767 17.2717 23.2812C17.2717 23.6858 17.5996 24.0137 18.0042 24.0137Z",
    fill: "#76CAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.051 42.5684C16.4555 42.5684 16.7834 42.2404 16.7834 41.8359C16.7834 41.4314 16.4555 41.1035 16.051 41.1035C15.6465 41.1035 15.3186 41.4314 15.3186 41.8359C15.3186 42.2404 15.6465 42.5684 16.051 42.5684Z",
    fill: "#76CAFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6389 24.9902H24.1077C23.838 24.9902 23.6194 24.7716 23.6194 24.502C23.6194 24.2323 23.838 24.0137 24.1077 24.0137H43.6389C43.9086 24.0137 44.1272 24.2323 44.1272 24.502C44.1272 24.7716 43.9086 24.9902 43.6389 24.9902Z",
    fill: "#4E5356"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6389 28.8965H24.1077C23.838 28.8965 23.6194 28.6778 23.6194 28.4082C23.6194 28.1386 23.838 27.9199 24.1077 27.9199H43.6389C43.9086 27.9199 44.1272 28.1386 44.1272 28.4082C44.1272 28.6778 43.9086 28.8965 43.6389 28.8965Z",
    fill: "#4E5356"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6389 32.8027H24.1077C23.838 32.8027 23.6194 32.5841 23.6194 32.3145C23.6194 32.0448 23.838 31.8262 24.1077 31.8262H43.6389C43.9086 31.8262 44.1272 32.0448 44.1272 32.3145C44.1272 32.5841 43.9086 32.8027 43.6389 32.8027Z",
    fill: "#4E5356"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6389 36.709H24.1077C23.838 36.709 23.6194 36.4904 23.6194 36.2207C23.6194 35.951 23.838 35.7324 24.1077 35.7324H43.6389C43.9086 35.7324 44.1272 35.951 44.1272 36.2207C44.1272 36.4904 43.9086 36.709 43.6389 36.709Z",
    fill: "#4E5356"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6389 40.6152H24.1077C23.838 40.6152 23.6194 40.3967 23.6194 40.127C23.6194 39.8572 23.838 39.6387 24.1077 39.6387H43.6389C43.9086 39.6387 44.1272 39.8572 44.1272 40.127C44.1272 40.3967 43.9086 40.6152 43.6389 40.6152Z",
    fill: "#4E5356"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 24.5,
    r: 7.5,
    fill: "#EDAD0C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22L51.5 27.5",
    stroke: "black",
    strokeWidth: 0.846154,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 22L46 27.5",
    stroke: "black",
    strokeWidth: 0.846154,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1194_25538",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#0294F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0274BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPromoHistory);
export default __webpack_public_path__ + "static/media/no-promo-history.da124c5f95bf26f22aac258bfa895088.svg";
export { ForwardRef as ReactComponent };